<div>
    <ng-container *ngIf="documentData" headerPanel>
        <app-component-button-header-back href="/account/doc/nav/collection/{{documentData.document.collection_id}}">
            {{ 'HEADERS.COLLECTION' | translate }}: {{ documentData.document.collection_name }}
        </app-component-button-header-back>
    </ng-container>

    <div>
        <div style="float: right">
            <app-signers (updateEvent)="emitRefresh.emit()"
                         *ngIf="documentData else loading"
                         [editPermission]="documentData.right.is_edit_signer"
                         [fileModel]="documentData.document"
                         [permissions]="documentData.right"
                         [signers]="documentData.signers"
            ></app-signers>

            <app-visors (updateApproveEvent)="emitRefreshApproved.emit()"
                        (updateEvent)="emitRefresh.emit()"
                        *ngIf="fileKey"
                        [editPermission]="documentData.right.is_edit_approver"
                        [fileKey]="fileKey"
                        [fileModel]="documentData.document"
                        [permissions]="documentData.right"
            ></app-visors>

            <h2 class="mt-3">{{ 'DOCUMENTS.TEXT.INFO' | translate }}</h2>
            <app-detail-property (refreshEmit)="emitRefresh.emit()"
                                 *ngIf="documentData && documentData.document"
                                 [canEdit]="documentData.right.is_edit_property"
                                 [customProperties]="documentData.document.custom_properties"
                                 [targetKey]="documentData.document.key"

                                 [target]="'file'"
            ></app-detail-property>
        </div>
    </div>

    <div style="max-width: 75%">
        <ng-template #loading>
            <app-component-loading></app-component-loading>
        </ng-template>

        <div *ngIf="showTabs && documentData.right.is_edit_settings">
            <div class="super__tabs">
                <div (click)="tab = 'view'" [class.active]="tab === 'view'"
                     [class.disabled_tab]="isPermissionsChanged"
                     class="super__tabs tab"
                     data-action="view">
                    <span>{{ 'DOCUMENTS.TEXT.VIEW' | translate }}</span>
                </div>
                <div (click)="tab = 'access'" [class.active]="tab === 'access'"
                     class="super__tabs tab"
                     data-action="access">
                    <span>{{ 'DOCUMENTS.TEXT.ACCESS' | translate }}</span>
                </div>
            </div>

            <div class="tab__content">
                <div class="tab__content">
                    <ng-container *ngIf="tab === 'access'">
                        <app-documents-access-settings
                                (changeEditEvent)="isPermissionsChanged = $event"
                                [target]="documentData.document"
                        ></app-documents-access-settings>
                    </ng-container>
                </div>
            </div>
        </div>

        <div *ngIf="fileKey && tab === 'view'">
            <app-component-doc-view
                    (emitLoadDocument)="onLoadData($event)"
                    [emitApproveDoc]="emitRefreshApproved"
                    [emitRefresh]="emitRefresh"
                    [fileData]="documentData"
                    [fileUkey]="fileKey"
                    [redirectToVersion]="true"
                    [versionUkey]="versionKey"
            ></app-component-doc-view>
        </div>
    </div>
</div>
